var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnifeStiletto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92px",
    height: "31.5px",
    viewBox: "0 0 92 31.5",
    enableBackground: "new 0 0 92 31.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected_Items"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.805,16.461c0-0.224-0.079-0.415-0.237-0.572 c-0.155-0.155-0.344-0.232-0.568-0.232c-0.224,0-0.415,0.077-0.573,0.232c-0.155,0.157-0.232,0.349-0.232,0.572 s0.077,0.413,0.232,0.568c0.158,0.158,0.349,0.236,0.573,0.236c0.224,0,0.413-0.078,0.568-0.236 C53.726,16.874,53.805,16.685,53.805,16.461z M2.377,11.257c2.377,0.732,4.884,1.029,7.52,0.889 c11.378-0.462,22.542-0.521,33.489-0.178c0.61-0.641,0.582-1.409-0.084-2.306c1.559-0.418,2.602,0.387,3.131,2.415h2.34 l0.435,0.543c18.559-0.04,32.681,0.977,42.367,3.047c-5.398,1.266-17.763,1.899-37.093,1.9l-0.271,0.281h-4.987l-0.45,0.212H46.27 c-0.528,0.489-0.372,1.214,0.469,2.179c-1.571,0.877-2.725,0.204-3.461-2.021c-10.783,0.404-21.969,0.404-33.558,0 c-2.601-0.089-5.066,0.293-7.396,1.146C0.528,16.593,0.546,13.89,2.377,11.257z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "guides"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnifeStiletto);
export default __webpack_public_path__ + "static/media/knife_stiletto.3941ce98bd9e7cc46e44f59f3c4e972a.svg";
export { ForwardRef as ReactComponent };